import {classNames, Fragment, observer, React, useEffect} from '@api'
import {Button, Icon, Menu, MenuDivider, MenuItem} from '@blueprintjs/core'
import {BorderAll, BorderClear, BorderHorizontal, BorderVertical} from '@material-ui/icons'
import {CardSizeSliderCatalog, CardSpacingSliderCatalog, CatalogActiveItemsFilterToggles, CatalogColumnSliderMaterial, GroupByToolbar, PerspectiveButtons, StackedCardSpreadSlider, StoresInstanceContext, useFilterStore, useStores} from '@modules'
import {useCatalogRootFlexLayoutStore} from '@stores/catalog/flexLayout'
import {SiteSearchFilterChip, CatalogFilterChips} from './'
import * as css from './chips/FilterChips.css'
import {globalStores, site, ui, useCatalog} from '@stores'
import {PrimaryIconButton} from 'centric-ui-components'
import {useMeasure} from 'react-use'
import * as styles from './FilterChipsToolbar.css'
import {Popover2, Tooltip2} from '@api'

interface MyProps {
  className?: string,
  children?: React.ReactNode
}

export const FilterChipsToolbar = observer<MyProps>(function FilterChipsToolbar({className, children}) {
  const {isGlobalStore, filterChipsToolbar, filterChipsToolbar: {hide, showSlidersInFilterChipsBar, showActiveToggles}} = useStores(),
    flexStore = useCatalogRootFlexLayoutStore(),
    showGroupByInFilterToolbar = false && (flexStore?.viewMode == 'card' || flexStore?.viewMode == 'pdf') /*&& flexLayout.activeCatalogTabs.length > 1*/,
    hasDataToShow = filterChipsToolbar.hasDataToShow || showGroupByInFilterToolbar,
    isShowing = hasDataToShow && !hide

  const [ref, {height}] = useMeasure()

  useEffect(() => {
    if (isGlobalStore) {
      site.sizes.filterChips.height = isShowing ? height : 0
    }
  }, [height, isShowing, hasDataToShow])

  // console.log({showGroupByInFilterToolbar, hasDataToShow, catalog, flexStore, ..._.pick(flexStore?.stores, 'isGlobalStore')})
  return (
    <div className={classNames(className, css.root)}
         ref={ref}
         data-type='FilterChips'
         data-visible={hasDataToShow || showGroupByInFilterToolbar}
         data-show={isShowing}
    >
      <div className={css.container} data-type='FilterChipsContainer'>
        {showGroupByInFilterToolbar && <GroupByToolbar/>}

			 <SiteSearchFilterChip/>
			 <CatalogFilterChips/>
           {(showSlidersInFilterChipsBar || showActiveToggles) &&
		    <div className={styles.right}>
              {/*<CardBorderOptionsToolbarButton />*/}

              {showSlidersInFilterChipsBar &&
			   <Fragment>
				   <StackedCardSpreadSlider className={styles.slider} tooltipLocation='bottom'/>
                 {/*<ImageSourceGridSliders />*/}
                 {/*<StackedCardScaleSlider className={styles.slider}/>*/}
				   <CatalogColumnSliderMaterial className={styles.slider}/>

				   <CardSpacingSliderCatalog className={styles.slider}/>
				   <CardSizeSliderCatalog className={styles.slider}/>
			   </Fragment>}

			    <CatalogActiveItemsFilterToggles className={css.activeToggles}/>

              {/*<ToggleShowFilterChipsToolbarButton/>*/}
		    </div>}
        {children}
      </div>
    </div>)
})

export const CardBorderOptionsToolbarButton = observer(function CardBorderOptionsToolbarButton() {
  const catalog = useCatalog(),
    {settings: {viewMode}} = catalog
  if (viewMode != 'card') return null

  const {settings: {borders, borders: {cardBorders, gridLines}}} = catalog

  return <Popover2
    interactionKind='click'
    content={<Menu className={styles.cardBorderMenu}>
      <MenuItem shouldDismissPopover={false} icon={cardBorders === true ? 'tick' : 'blank'} text='Card Borders' onClick={() => borders.cardBorders = cardBorders !== true}/>
      <MenuDivider title='Grid Lines'/>
      <MenuItem shouldDismissPopover={false} labelElement={<BorderClear/>} text='None' icon={gridLines === 'none' ? 'tick' : 'blank'} onClick={() => borders.gridLines = 'none'}/>
      <MenuItem shouldDismissPopover={false} labelElement={<BorderHorizontal/>} text='Horizontal' icon={gridLines === 'horizontal' ? 'tick' : 'blank'} onClick={() => borders.gridLines = 'horizontal'}/>
      <MenuItem shouldDismissPopover={false} labelElement={<BorderVertical/>} text='Vertical' icon={gridLines === 'vertical' ? 'tick' : 'blank'} onClick={() => borders.gridLines = 'vertical'}/>
      <MenuItem shouldDismissPopover={false} labelElement={<BorderAll/>} text='Both' icon={gridLines === 'both' ? 'tick' : 'blank'} onClick={() => borders.gridLines = 'both'}/>
    </Menu>}
  >
    <Button className={styles.borderToolbarButton} minimal icon='grid-view'
            title='Borders and Grid Lines'/>
  </Popover2>
})
export const ToggleShowFilterChipsToolbarButton = observer(function ToggleShowFilterChipsToolbarButton() {
  const {filterChipsToolbar, flexLayoutCatalogRoot} = useStores()

  if (!filterChipsToolbar?.hasDataToShow) return null

  const {hide, toggleHide} = filterChipsToolbar

  return (
    <PrimaryIconButton
      tooltip={`Show ${flexLayoutCatalogRoot ? `Tab Toolbar` : `Secondary Toolbar`}`}
      className={css.toggleFilterBar} active={!hide} onClick={toggleHide} icon={<Icon icon='filter'/>}/>
  )
})


// WEBPACK FOOTER //
// ./src/modules/catalog/FilterChipsToolbar/FilterChipsToolbar.tsx